// Billboard Background Video Playback Controls
const media = document.getElementById("background-video");
const toggle = document.getElementById("toggle");
// console.log(media, toggle);

function videoControls() {
  if (media.paused) {
    //toggle.innerHTML = 'Play Video';
    toggle.innerHTML = '<i class="fas fa-pause"></i> Pause Video';
    toggle.classList.remove(`paused`);
    toggle.classList.add(`playing`);
    media.play();
  } else {
    //toggle.innerHTML = "Pause Video";
    toggle.innerHTML = '<i class="fas fa-play"></i> Play Video';
    toggle.classList.remove(`playing`);
    toggle.classList.add(`paused`);
    media.pause();
  }
}
if (toggle) {
  toggle.addEventListener("click", videoControls);
}

/**
 * Checks to see if the Billboard page section has a multi-layout view
 */

const multiLayout = document.querySelector(
  ".multiple-location-billboard-content"
);

if (multiLayout) {
  const siteHeader = document.querySelector(".site-header");
  siteHeader.style.display = "none";
}
